import app from './js/app';
import router from './js/router';
import token from './js/token';

app.lib.router = router;
app.lib.token = token;

app.fn.run();
